var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{attrs:{"page-size":20,"pager-count":11,"layout":"prev, pager, next","total":1000}})
}
var staticRenderFns = []

export { render, staticRenderFns }